module.exports = __webpack_public_path__ + "static/media/frances.b9eb91b3.png";